module.exports = __webpack_public_path__ + "static/media/icon-shopping_cart.6011f750.svg";